'use client'

import { usePageTracking } from '@/hooks/use-page-tracking'

/**
 * Render-nothing component that activates page view tracking.
 * Mounted in providers.tsx alongside UtmTracker and other trackers.
 */
export function PageTracker() {
  usePageTracking()
  return null
}
